import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { noop } from "lodash";
import classNames from "classnames";

// Components
import Link from "./Link";

// Stylesheet
import "./Icon.scss";

/**
 *  For Google Material icons
 *      - https://google.github.io/material-design-icons/#icon-images-for-the-web
 *      - https://material.io/tools/icons/
 */
export default class Icon extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.any,
    materialIconName: PropTypes.string.isRequired,
    className: PropTypes.any,
    linkProps: PropTypes.object,
    color: PropTypes.oneOf(["white", "teal", "rose", "steel", "navy", "gold"]),
    title: PropTypes.string,
  };

  static defaultProps = {
    color: "navy",
    onClick: noop,
  };

  renderIcon = () => {
    const {
      onClick,
      children,
      materialIconName,
      className,
      linkProps,
      color,
      ...rest
    } = this.props;

    return (
      <i
        className={classNames(
          "icon",
          "material-icons",
          `icon_${this.props.color}`,
          this.props.className
        )}
        onClick={this.props.onClick}
        {...rest}
      >
        {this.props.materialIconName}
      </i>
    );
  };

  render() {
    const IconComponent = this.renderIcon();

    if (this.props.linkProps) {
      const linkClassName = classNames(
        "icon_link",
        this.props.linkProps.className
      );
      const { className, ...rest } = this.props.linkProps;

      return (
        <Link className={linkClassName} {...rest}>
          {IconComponent}

          {this.props.children}
        </Link>
      );
    }

    return IconComponent;
  }
}
